import prepareOptions from '../../prepareOptions';
import { VALUE_10, VALUE_24, VALUE_48, VALUE_72 } from './values';

export default prepareOptions([VALUE_10, VALUE_24, VALUE_48, VALUE_72]);
